/**
 * ReactionChips - as reações aplicadas numa mensagem, do contato
 * (`reaction`) e do operador (`reactionFromMe`), como os chips embaixo da
 * bolha no WhatsApp. Clicar no chip do operador abre o seletor para trocar
 * ou remover. Compartilhado pelos 3 shells.
 *
 * Props: { reaction, reactionFromMe, align: 'left'|'right', colors,
 *          onChangeMine(emoji|null) }  (onChangeMine ausente = só leitura)
 */
import React, { useState } from 'react';
import ReactionPicker from './ReactionPicker';

const Chip = ({ emoji, mine, colors, onClick, title }) => (
  <button
    type="button"
    onClick={onClick}
    title={title}
    style={{
      display: 'inline-flex', alignItems: 'center', gap: 4,
      padding: '1px 7px', borderRadius: 999, fontSize: 14, lineHeight: '18px',
      backgroundColor: colors.bgPrimary,
      border: `1px solid ${mine ? colors.accentPrimary : colors.borderColor}`,
      color: colors.textPrimary, cursor: onClick ? 'pointer' : 'default',
      boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
    }}
  >
    <span>{emoji}</span>
    {mine && <span style={{ fontSize: 10, color: colors.textTertiary }}>você</span>}
  </button>
);

const ReactionChips = ({ reaction, reactionFromMe, align = 'left', colors, onChangeMine }) => {
  const [open, setOpen] = useState(false);
  if (!reaction && !reactionFromMe) return null;

  return (
    <div style={{
      position: 'relative', display: 'flex', gap: 4, marginTop: -8, marginBottom: 2,
      justifyContent: align === 'right' ? 'flex-end' : 'flex-start',
      padding: align === 'right' ? '0 10px 0 0' : '0 0 0 10px',
    }}>
      {reaction && <Chip emoji={reaction} colors={colors} title="Reação do contato" />}
      {reactionFromMe && (
        <Chip
          emoji={reactionFromMe}
          mine
          colors={colors}
          title={onChangeMine ? 'Trocar ou remover sua reação' : 'Sua reação'}
          onClick={onChangeMine ? (e) => { e.stopPropagation(); setOpen((v) => !v); } : undefined}
        />
      )}
      {open && onChangeMine && (
        <div style={{
          position: 'absolute', bottom: '100%', zIndex: 20,
          [align === 'right' ? 'right' : 'left']: 0, marginBottom: 4,
        }}>
          <ReactionPicker
            compact
            current={reactionFromMe}
            colors={colors}
            onPick={(emoji) => { setOpen(false); onChangeMine(emoji); }}
          />
        </div>
      )}
    </div>
  );
};

export default ReactionChips;
